export default __webpack_public_path__ + "static/media/3132 spice rack D side.30e2ef18.png";